import React from 'react'
import { Box, Typography } from 'transfix-ui/core'

export const PaymentTerms = () => (
  <Box mt={2}>
    <Typography color='textPrimary' variant='subtitle1'>
      30 day payment through TriumphPay
    </Typography>
    <Box>Payment will take place within 30 days of approved Proof of Delivery (POD).</Box>
    <Box>
      Quick Pay options are offered directly through TriumphPay. To select Quick Pay on this load,
      please go through{' '}
      <a href='https://secure.triumphpay.com' rel='noreferrer' target='_blank'>
        TriumphPay
      </a>
      .
    </Box>
  </Box>
)
